import React, { useState, useEffect } from "react";
import { Line } from "react-chartjs-2";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import './ViewRegion.css'
import Response_Loading_processing from "../../../../src/layout/Others/Response_Loading_processing";

const ViewRegion = ({ partnerId }) => {
  const { fetchRequest } = useMyContext();
  const BaseUrl = process.env.REACT_APP_Baseurl;
  const role = localStorage.getItem('role');
  const userId = localStorage.getItem('user_id');

  // Determine which partner context to use
  const effectivePartnerId = partnerId || (role === "4" ? userId : undefined);
  
  const [datas, setDatas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState("");
  const [selectedModerator, setSelectedModerator] = useState("0");
  const [chartData, setChartData] = useState({
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
    datasets: []
  });

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await fetchRequest({
        method: "GET",
        url: `${BaseUrl}/analytics/region-views`,
        params: {
          partner_id: effectivePartnerId,
          search: filter || undefined,
          moderator: selectedModerator !== "0" ? selectedModerator : undefined
        }
      });

      if (response?.status) {
        setDatas(response.data || []);
        if (response.chart_data) {
           setChartData(response.chart_data);
        }
      }
    } catch (error) {
      console.error("Error fetching region data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [partnerId, selectedModerator]);

  const columns = [
    {
      dataField: "id",
      text: "ID",
      sort: true
    },
    {
      dataField: "video_name",
      text: "VIDEO NAME",
      sort: true
    },
    {
      dataField: "country_name",
      text: "COUNTRY NAME",
      sort: true
    },
    {
      dataField: "ip_number",
      text: "IP NUMBER",
    },
    {
      dataField: "views",
      text: "VIEWS",
      sort: true
    },
  ];

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: true },
    },
    scales: {
      y: { beginAtZero: true }
    }
  };

  return (
    <div className="m-0 p-0">
      <section className="section container-fluid pt-3">
        <div id="content-page" className="content-page">
          <div className="iq-card-header d-flex justify-content-between align-items-center">
            <div className="iq-header-title p-0">
              <h4 className="card-title">View By Region</h4>
            </div>
          </div>
          
          <div className="row mt-4">
            <div className="col-lg-8">
                <div className="iq-card p-3" style={{ height: "350px" }}>
                    <Line options={chartOptions} data={chartData} />
                </div>
            </div>
            <div className="col-lg-4">
                <div className="iq-card p-4">
                    <h5>Filter Options</h5>
                    <div className="mt-3">
                        <label className="form-label">Moderator / Category</label>
                        <select 
                            className="form-select" 
                            value={selectedModerator}
                            onChange={(e) => setSelectedModerator(e.target.value)}
                        >
                            <option value="0">All Regions</option>
                            <option value="india">India</option>
                            <option value="dubai">UAE</option>
                            <option value="america">USA</option>
                        </select>
                    </div>
                </div>
            </div>
          </div>

          <div className="iq-card mt-4 p-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="flex-grow-1" style={{ maxWidth: "400px" }}>
                    <input
                        type="text"
                        placeholder="Search regions or videos..."
                        className="form-control"
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                    />
                </div>
                <button className="btn btn-primary ms-3" onClick={fetchData}>Refresh Data</button>
            </div>

            <div className="bootstrapTable">
              <BootstrapTable
                keyField="id"
                columns={columns}
                data={datas}
                pagination={paginationFactory()}
                noDataIndication={() => (
                  <div className="text-center p-4">
                    {loading ? <Response_Loading_processing /> : "No records found for this partner/region"}
                  </div>
                )}
                hover
                striped
                bordered={false}
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ViewRegion;
